/**
 * Словник: en.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_en.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Waiting for the other participant...",
  connectionLost: "Connection lost",
  peerLeft: "👋 The other participant left the call",
  connectionError: "🚫 Connection error",
  connectionFailedTryAgain: "🚫 Failed to connect to the server. Please try again.",
  reconnectionFailed: "🚫 Connection lost. Failed to restore after {attempts} attempts.",
  connectionErrorWithDetails: "🚫 Connection error: {error}",
  speakerLoud: "Loud",
  speakerEar: "Earpiece",
  copyRoomId: "Copy room ID",
  share: "Share",
  linkCopied: "🔗 Link copied!",
  idCopied: "🆔 ID copied!",
  startMeeting: "Start Meeting",
  chooseAction: "Choose an action",
  createNewRoom: "New Room",
  scheduleCall: "Schedule a Call",
  calendarOpened: "📅 Calendar opened successfully",
  linkCopiedToClipboard: "🔗 Link copied to clipboard",
  enterRoomId: "Enter room ID",
  roomIdValidationError: "Room ID can only contain letters, numbers and hyphens",
  joinRoom: "JOIN",
  termsAndPrivacyHelp: "Terms & Privacy | Help",
  invite: "Invite",
  mySettings: "My Settings",
  peerSettings: "Peer Settings",
  blockRemoteControl: "Block remote control",
  iAgreeToTerms: "I agree to the service terms",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  howToUse: "How to use",
  termsAcceptanceRequired: "You must agree to the terms to use the service",
  ok: "OK",
  permissionsRequired: "Permissions Required",
  permissionsNeededMessage: "This app needs the following permissions to work properly:",
  permissionsNote: "Note: When you change permissions in Settings, iOS will restart the app. This is normal behavior.",
  permissionsEnableMessage: "Please enable these permissions in your device settings to continue.",
  cancel: "Cancel",
  openSettings: "Open Settings",
  websocketError: "WebSocket error",
  roomFull: "Room is full",
  timeExpired: "Time expired",
  remaining: "rem.",
  mediaPermissionsRequired: "Video calls require access to camera and microphone. Please grant permissions in your browser.",
  mediaPermissionsRequiredMobile: "Video calls require access to camera and microphone. Please grant permissions in app settings.",
  browserSettings: "Browser settings",
  openAppSettings: "Open settings",
  grantPermissions: "Grant permissions",
  permissionsNotGranted: "Permissions not granted. Please grant permissions to continue.",
  permissionRequestError: "Error requesting permissions: {error}",
  camera: "Camera",
  microphone: "Microphone",
  cameraDescription: "For video transmission",
  microphoneDescription: "For audio transmission",
  continueWithoutPermissions: "Continue without permissions",
  mediaPermissionsRequiredFallback: "Media permissions required for video calls. Please grant permissions in browser settings.",
  mediaPermissionsRequiredMobileFallback: "Media permissions required for video calls. Please grant permissions in app settings.",
  browserSettingsFallback: "Browser Settings",
  openAppSettingsFallback: "Open Settings",
  permissionsPermanentlyDenied: "Permissions permanently denied. Please enable them in app settings.",
  continueText: "Continue",
  mirror: "Mirror",
  fitContain: "Contain",
  fitCover: "Cover",
  switchCamera: "Switch",
  block: "Block ctrl",
  pip: "PiP",
  mic: "Mic",
  video: "Video",
  speaker: "Speaker",
  readyToConnect: "Ready to connect?",
  startOneOnOne: "Start a video call",
  createPrivateLink: "Link ready in a second",
  welcomeExplainer: "Create a link and send it to anyone. It opens even without the app.",
  joinHaveLink: "Have a link?",
  joinFieldHint: "Paste a link or ID",
  roomInputInvalid: "Paste a call link or a room ID (letters, digits and hyphens)",
  guestTitle: "You're invited to a video call",
  guestBody: "The room is ready. The other person will see you as soon as you join.",
  guestJoin: "Join",
  guestFreeNote: "Joining is always free",
  guestCreateOwn: "Create my own room",
  guestInvalidTitle: "This link looks broken",
  guestInvalidBody: "Ask for the link again or create your own room.",
  inviteCardTitle: "Your room is ready",
  inviteCardBody: "Send the link to the person you want to talk to",
  inviteShareLink: "Share link",
  inviteCopy: "Copy",
  inviteBrowserHint: "Opens in any browser. No need to install the app.",
  inviteSentHint: "Sent? The other person will appear here as soon as they open the link.",
  inviteShareMessage: "Join my video call on One2One 👋\nJust open the link. It works in your browser, nothing to install:\n{link}",
  copyLink: "Copy link",
  consentBannerText: "May we collect usage statistics? They show us which features people use. Call content is never included.",
  consentAllow: "Allow",
  consentDeny: "Don't allow",
  privacySettingsLink: "Statistics settings",
} as const;
